import type {
  Diametre,
  FrameStyle,
  HandStyle,
  Mecanisme,
  Numerals,
  Option,
} from '../types/clock'

export const diametres: Option<Diametre>[] = [
  { value: 25, label: '25 cm', detail: 'Bureau, cuisine', prix: 39 },
  { value: 30, label: '30 cm', detail: 'Le plus choisi', prix: 49 },
  { value: 40, label: '40 cm', detail: 'Pièce à vivre', prix: 69 },
]

export const numerals: Option<Numerals>[] = [
  { value: 'arabes', label: 'Chiffres arabes', detail: 'Blanc contour noir', prix: 0 },
  { value: 'romains', label: 'Chiffres romains', detail: 'Classique', prix: 0 },
  { value: 'batons', label: 'Index bâtons', detail: 'Épuré', prix: 0 },
  { value: 'aucun', label: 'Sans repère', detail: 'Image seule', prix: 0 },
]

export const hands: Option<HandStyle>[] = [
  { value: 'noir', label: 'Noir mat', prix: 0 },
  { value: 'or', label: 'Doré', prix: 3 },
  { value: 'blanc', label: 'Blanc', prix: 0 },
]

export const frames: Option<FrameStyle>[] = [
  { value: 'aucun', label: 'Sans cadre', detail: 'Bord imprimé', prix: 0 },
  { value: 'chene', label: 'Chêne clair', detail: 'Bois massif', prix: 14 },
  { value: 'noyer', label: 'Noyer foncé', detail: 'Bois massif', prix: 14 },
]

export const mecanismes: Option<Mecanisme>[] = [
  { value: 'silencieux', label: 'Quartz silencieux', detail: 'Sans tic-tac', prix: 0 },
  { value: 'trotteuse', label: 'Quartz + trotteuse', detail: 'Aiguille des secondes', prix: 5 },
]

export const PRIX_GRAVURE = 6
export const PRIX_PHOTO_PERSO = 9
